module.exports = __webpack_public_path__ + "static/media/isup.f2edeea9.png";